<img
  class="loading-message__spinner"
  [src]="spinnerSrc()"
  [style.width.px]="preset().spinner"
  [style.height.px]="preset().spinner"
  alt=""
  aria-hidden="true"
/>
@if (showText()) {
  @if (message(); as freeText) {
    <span
      class="loading-message__text"
      [class.loading-message__text--large]="size() !== 'mini'"
      [class.loading-message__text--light]="theme() === 'light'"
    >
      {{ freeText }}
    </span>
  } @else {
    <app-loading-text [text]="text()" [size]="preset().text" [mode]="theme()"></app-loading-text>
  }
}
